var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13362",
    "data-name": "Group 13362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.088,
    height: 18.608,
    viewBox: "0 0 26.088 18.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5196",
    "data-name": "Rectangle 5196",
    width: 26.088,
    height: 18.608,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13361",
    "data-name": "Group 13361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45524",
    "data-name": "Path 45524",
    d: "M0,8.318a4.153,4.153,0,0,1,.722-1.29A17.778,17.778,0,0,1,4.787,3.1L3.208,1.519A.984.984,0,0,1,4.763.32L21.342,16.9a.978.978,0,0,1-1.249,1.5l-2.448-2.4a14.72,14.72,0,0,1-8.3.252,16.109,16.109,0,0,1-8.025-5.269A7.976,7.976,0,0,1,0,8.98ZM8.073,6.384c-.167,0-.453,1.359-.478,1.559a5.5,5.5,0,0,0,6.08,6.131,4.71,4.71,0,0,0,1.58-.458l-1.4-1.451a9.937,9.937,0,0,0-1.043.024A3.635,3.635,0,0,1,9.472,8.8,7.215,7.215,0,0,0,9.5,7.81Z",
    transform: "translate(0 -0.001)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45525",
    "data-name": "Path 45525",
    d: "M124.259,8.187a14.624,14.624,0,0,1,8.313-.241,16.181,16.181,0,0,1,8.414,5.8c1.208,1.6,1.208,2.06,0,3.658a15.768,15.768,0,0,1-3.909,3.665l-3.234-3.234a7.888,7.888,0,0,0,.323-.935,5.49,5.49,0,0,0-7.582-6.324Z",
    transform: "translate(-115.804 -6.949)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45526",
    "data-name": "Path 45526",
    d: "M185.377,78.5,181.15,74.27a3.632,3.632,0,0,1,4.227,4.227",
    transform: "translate(-168.824 -69.161)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconClose);
export default __webpack_public_path__ + "static/media/eye-icon-close.2a4f3a1566bc3718936f14e43abf94e8.svg";
export { ForwardRef as ReactComponent };